import React from 'react';
import { useSetResolved } from '@wearejh/m2-pwa-engine/lib/router/useSetResolved';
import { Helmet } from 'react-helmet-async';

import { Branch } from 'src/components/GoogleMaps/GoogleMapsTypes';

import { BranchDetail } from './BranchViewQuery';
import { BranchViewSchema } from './BranchViewSchema';
import { BranchDetailView } from './BranchDetailView';

export type BranchesViewContentProps = {
    branches: Branch[];
    detail: BranchDetail;
    name: string;
};

export const BranchViewContent = React.memo(function BranchViewContent(props: BranchesViewContentProps) {
    const { detail } = props;

    useSetResolved();

    return (
        <>
            <Helmet>
                <meta name="description" content={detail.meta_description} />
                <meta name="keywords" content={detail.meta_keywords} />
                <meta name="og:description" content={detail.meta_description} />
                <meta name="og:title" content={detail.meta_title} />
                <title>{detail.meta_title}</title>
            </Helmet>
            <BranchViewSchema detail={detail} />
            <BranchDetailView detail={detail} />
        </>
    );
});
